import { render, staticRenderFns } from "./mailing-list-signup.vue?vue&type=template&id=4bfeedfc&scoped=true&"
import script from "./mailing-list-signup.vue?vue&type=script&lang=js&"
export * from "./mailing-list-signup.vue?vue&type=script&lang=js&"
import style0 from "./mailing-list-signup.vue?vue&type=style&index=0&id=4bfeedfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfeedfc",
  null
  
)

export default component.exports